import React, { useContext } from 'react';

import { ThemingContext } from '../../hoc/Theming/Theming';

import './Button.scss';

export const Button = (props) => {
  const styling = useContext(ThemingContext)

  const {
    inputType,
    rounded,
    onClick,
    size,
    outlined,
    active,
    danger,
    icon,
    children,
    closeOnClick,
    className,
    form,
    disabled,
  } = props;

  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={inputType}
      className={`button btn-${size} 
      ${rounded && `btn-rounded`}
      ${outlined && !active && `btn-outlined`}
      ${outlined && active && `btn-outlined-active`}
      ${danger && `btn--danger`}
      ${closeOnClick && 'cursor__off'}
      ${className}
      `}
      form={form}
      style={outlined ? styling.component.button.outlined : styling.component.button.primary}
    >
      {icon ? <i className={`fa ${icon} btn-icon`}></i> : null}
      {children}
      {closeOnClick ? (
        <button
          className={`fa fa-times btn-close`}
          onClick={closeOnClick}
        ></button>
      ) : null}
    </button>
  );
};

export default Button;

// Props
//
// Required
// size: 'tiny' || 'small' || 'medium' || 'large'
//
// Optional
// inputType: 'submit' || null
// rounded: Bool
// outlined: Bool
// active: Bool
// danger: Bool
// icon: fa-code (String)
// closeOnClick: func()
// disabled: Bool